import React from 'react';

const MarqueeText = ({ text }) => {
  return (
    <div className="overflow-hidden whitespace-nowrap bg-black text-white py-3">
      <div className="inline-block animate-marquee">
        <span className="mx-6 text-xs font-light tracking-widest uppercase">{text}</span>
        <span className="mx-6 text-xs font-light tracking-widest uppercase">{text}</span>
        <span className="mx-6 text-xs font-light tracking-widest uppercase">{text}</span>
        <span className="mx-6 text-xs font-light tracking-widest uppercase">{text}</span>
        <span className="mx-6 text-xs font-light tracking-widest uppercase">{text}</span>
        <span className="mx-6 text-xs font-light tracking-widest uppercase">{text}</span>
      </div>
    </div>
  );
};

export default MarqueeText;